// extracted by mini-css-extract-plugin
module.exports = {"delta":"delta_delta___yR_y"};